module.exports = __webpack_public_path__ + "img/como-funciona-3.5acb4ca9.jpg";